var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.213,
    height: 30.365,
    viewBox: "0 0 29.213 30.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31531",
    "data-name": "Rectangle 31531",
    width: 29.213,
    height: 30.365,
    transform: "translate(0 0)",
    fill: "#3c3c3b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14161",
    "data-name": "Group 14161",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12672",
    "data-name": "Group 12672",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38484",
    "data-name": "Path 38484",
    d: "M28.023,7.273A7.273,7.273,0,1,1,20.751,0a7.273,7.273,0,0,1,7.273,7.273",
    transform: "translate(-6.144 0)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38485",
    "data-name": "Path 38485",
    d: "M19.714,28.516a8.674,8.674,0,0,1-10.216,0C5.167,30.452,1.716,34.778.114,40.258c-.439,1.5.449,3.105,1.705,3.105H27.393c1.256,0,2.146-1.6,1.705-3.105-1.6-5.48-5.054-9.806-9.384-11.742",
    transform: "translate(0 -12.999)",
    fill: "#3c3c3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.55f63e46b4be6a88a6acd5af553c28a5.svg";
export { ForwardRef as ReactComponent };